export default {
    "data":{
        "h5":{
            "imgList":[
                "https://s20.lgstatic.com/growth/activity/20220627/1656314085450.png",
                "https://s21.lgstatic.com/growth/activity/20220627/1656314144332.png",
                "https://s20.lgstatic.com/growth/activity/20220627/1656314213569.png",
                // "https://s20.lgstatic.com/growth/activity/20220415/1649993390870.png",
                "https://s21.lgstatic.com/growth/activity/20220627/1656315824858.png",
                "https://s21.lgstatic.com/growth/activity/20220627/1656315906065.png",
                "https://s20.lgstatic.com/growth/activity/20220627/1656314424770.png",
                "https://s21.lgstatic.com/growth/activity/20220415/1650007946999.png",
                "https://s21.lgstatic.com/growth/activity/20220415/1649993498410.png"
                // "https://s21.lgstatic.com/growth/activity/20210513/1620874685354.png"
            ],
            "swiperList":[
                "https://s20.lgstatic.com/growth/activity/20210820/1629440463952.png",
                "https://s21.lgstatic.com/growth/activity/20210820/1629440510627.png",
                "https://s20.lgstatic.com/growth/activity/20210820/1629440534255.png"
            ],
            "sectionSwiper":{
                "swiper":[
                    "https://s20.lgstatic.com/growth/activity/20220415/1650009299588.png",
                    "https://s21.lgstatic.com/growth/activity/20220415/1650009309536.png",
                    "https://s20.lgstatic.com/growth/activity/20220415/1650009320670.png",
                    "https://s21.lgstatic.com/growth/activity/20220415/1650009335031.png"
                ],
                "img":"https://s20.lgstatic.com/growth/activity/20220314/1647252036364.png"
            },
            "button":{
                "footer":"https://s20.lgstatic.com/growth/activity/20210825/1629879577572.png",
                "more":"https://s20.lgstatic.com/growth/activity/20220415/1650008503963.png",
                "more2":"https://s21.lgstatic.com/growth/activity/20220415/1650010048942.png"
            }
        },
        "pc":{
            "imgList":[
                "https://s20.lgstatic.com/growth/activity/20220627/1656317083851.png",
                "https://s21.lgstatic.com/growth/activity/20220627/1656317109531.png",
                "https://s20.lgstatic.com/growth/activity/20220627/1656317584971.png",
                "https://s20.lgstatic.com/growth/activity/20220627/1656317622770.png",
                "https://s20.lgstatic.com/growth/activity/20220627/1656317649204.png",
                "https://s20.lgstatic.com/growth/activity/20220627/1656317985056.png",
                "https://s20.lgstatic.com/growth/activity/20220627/1656318047581.png"
            ],
            "buttonList":{
                "more":"https://s20.lgstatic.com/growth/activity/20220418/1650265523015.png",
                "more2":"https://s20.lgstatic.com/growth/activity/20220418/1650265722296.png",
                "footer":"https://s21.lgstatic.com/growth/activity/20220418/1650263837416.png"
            },
            "title":{
                "sw":"https://s21.lgstatic.com/growth/activity/20220419/1650338209429.png",
                "student":"https://s21.lgstatic.com/growth/activity/20220627/1656317928775.png"
            },
            "swiperList":[
                "https://s20.lgstatic.com/growth/activity/20210824/1629793928159.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629793935991.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629793943254.png"
            ],
            "imgList1":[
                "https://s21.lgstatic.com/growth/activity/20210817/1629183248291.png",
                "https://s20.lgstatic.com/growth/activity/20220314/1647252165534.png"
            ],
            "studentList":[
                "https://s21.lgstatic.com/growth/activity/20220418/1650264337193.png",
                "https://s21.lgstatic.com/growth/activity/20220418/1650264347102.png",
                "https://s20.lgstatic.com/growth/activity/20220418/1650264357319.png",
                "https://s21.lgstatic.com/growth/activity/20220418/1650264415307.png"
            ]
        }
    }
}
